module.exports = __webpack_public_path__ + "img/logo-gray-xero.a065e63d.png";